import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';

import AcceptAgreementContainer from './components/AcceptAgreementContainer';
import BackgroundSlidesPageContainer from '../login/components/shared/BackgroundSlidesPageContainer';
import PageWrapper from '../login/components/shared/PageWrapper';
import useBackgroundSlides, { createLoginSlides } from '../login/components/hooks/useBackgroundSlides';
import { fetchUserData } from '../login/ducks/loginActions';

const slides = createLoginSlides(12);

const AcceptAgreement = () => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const { imageTransition } = useBackgroundSlides(slides);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!currentUser || Object.keys(currentUser).length === 0) {
      dispatch(fetchUserData());
    }
  }, [dispatch]);

  useEffect(() => {
    if (Object.keys(currentUser).length
      && (currentUser.primaryAdmin !== 1 || currentUser.organizationHasValidAgreement === true)) {
      dispatch(push('/'));
    }
  }, [currentUser, dispatch]);

  return (
    <BackgroundSlidesPageContainer
      imageTransition={imageTransition}
    >
      <Helmet>
        <title>Accept Agreement | TeamBuildr</title>
      </Helmet>
      <PageWrapper>
        <AcceptAgreementContainer />
      </PageWrapper>
    </BackgroundSlidesPageContainer>
  );
};

export default AcceptAgreement;
